const initialState = {
  myClientAnalysePortfolio: false,
  myClientButtonActionType: "",
  client_id: "",
  risk_profile: {},
  client_name: "",
};

function myClients(state = JSON.parse(JSON.stringify(initialState)), action) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);

  switch (type) {
    case "SET_MYCLIENTS_ANALYSE_PORTFOLIO_ACTIVE":
      newState.myClientAnalysePortfolio = payload;
      break;

    case "SET_MYCLIENT_QUESTIONNAIRE_ACTION_TYPE":
      newState.myClientButtonActionType = payload;
      break;

    case "SET_MYCLIENTS_CLIENT_ID":
      newState.client_id = payload;
      break;

    case "SET_MYCLIENTS_RISK_PROFILE":
      newState.risk_profile = payload.risk_profile;
      newState.client_name = payload.client_name;

      break;
    case "RESET_MYCLIENTS_ANALYSE":
      newState.myClientAnalysePortfolio = false;
      newState.myClientButtonActionType = "";
      newState.client_id = "";
      newState.risk_profile = {};
      newState.client_name = "";
      break;
    default:
      return state;
  }

  return newState;
}

export default myClients;



// WEBPACK FOOTER //
// ./src/reducers/myClients.reducer.js